// extracted by mini-css-extract-plugin
export default {"table":"CadenceModal_table__AoDk9"};